<div class="offcanvas offcanvas-end" data-bs-scroll="true" tabindex="-1" id="rightSideBar" aria-labelledby="rightSideBarLabel">
  <div class="offcanvas-header">
    <!-- <h5 class="offcanvas-title" id="rightSideBarLabel">Backdrop with scrolling</h5> -->
    <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body">
    <ng-template sideBarHost></ng-template>
  </div>
</div>